import React from 'react'
import PropTypes from 'prop-types'

import { Heading } from 'Components/Blocks/_Legacy'
import AnimatedScrollBox from 'Components/Blocks/_Legacy/AnimatedScrollBox'
import { Motion, Wrapper } from 'Components/UI'

import solutionGlyph from 'Assets/_Legacy/Svg/solution.svg'

import { Container, Content, ImageHolder, LeftSide } from './styles'

import { SEQUENCES } from '../sequences'

function Solution({ data }) {
  return (
    <Container>
      <Wrapper>
        <Content>
          <LeftSide>
            <Motion>
              <Heading
                horizontalAlign="left"
                subTitleText={data.subtitleText}
                tagGlyph={solutionGlyph}
                tagText={data.overheadText}
                titleText={{
                  first: {
                    text: data.titleTextFirst,
                    bold: data.firstBold,
                  },
                  second: {
                    text: data.titleTextSecond,
                    bold: data.secondBold,
                  },
                }}
                verticalAlign="center"
              />
            </Motion>
          </LeftSide>
          <ImageHolder>
            <AnimatedScrollBox sequence={SEQUENCES.solution} />
          </ImageHolder>
        </Content>
      </Wrapper>
    </Container>
  )
}

Solution.defaultProps = {
  data: {},
}

Solution.propTypes = {
  data: PropTypes.object,
}

export default Solution
